import {useEffect, useState} from 'react';
import {convertCurrency, convertCurrencySync, clearCurrencyRatesCache} from '../utils/helpers/currencyConverter/currencyConverter';

/**
 * Хук для конвертации валют
 * Загружает курсы валют при первом использовании и предоставляет функцию конвертации
 */
export function useCurrencyConverter() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Предзагружаем курсы валют при монтировании компонента
    const loadRates = async () => {
      try {
        // Импортируем loadCurrencyRates напрямую, чтобы гарантировать загрузку кэша
        const currencyConverter = await import('../utils/helpers/currencyConverter/currencyConverter');
        // Загружаем курсы напрямую
        await currencyConverter.loadCurrencyRates();
        setIsReady(true);
      } catch (error) {
        console.error('[useCurrencyConverter] Failed to load currency rates:', error);
        // Все равно помечаем как готовый, чтобы не блокировать UI
        setIsReady(true);
      }
    };

    loadRates();
  }, []);

  /**
   * Конвертирует сумму из одной валюты в другую
   * Использует синхронную версию, если кэш загружен, иначе асинхронную
   */
  const convert = async (amount: number, fromCurrencyId: number, toCurrencyId: number): Promise<number> => {
    if (isReady) {
      // Используем синхронную версию, если кэш уже загружен
      return convertCurrencySync(amount, fromCurrencyId, toCurrencyId);
    }
    // Иначе используем асинхронную версию
    return await convertCurrency(amount, fromCurrencyId, toCurrencyId);
  };

  /**
   * Синхронная версия конвертации (использует кэш, если он загружен)
   */
  const convertSync = (amount: number, fromCurrencyId: number, toCurrencyId: number): number => {
    return convertCurrencySync(amount, fromCurrencyId, toCurrencyId);
  };

  return {
    convert,
    convertSync,
    isReady,
    clearCache: clearCurrencyRatesCache,
  };
}


